import { Button, HStack, Image, Text, Wrap } from "@chakra-ui/react"

const VariantOptionValues = ({ option, optionIndex, selectedOption, variants = [], onSelectOption }) => {
    const getOptionImage = (valueId) => {
        if (optionIndex !== 0) return null;

        const variantWithImage = variants.find(variant => {
            const matched = variant.options?.find(o => o.id === option.id)?.value === valueId;
            if (!matched) return false;
            return !!(variant?.image || variant?.images?.[0]);
        });

        return variantWithImage?.image || variantWithImage?.images?.[0] || null;
    }

    return (
        <Wrap>
            {(option?.values_title || []).map((value) => {
                const optionImage = getOptionImage(value.id);
                const optionImageSrc = optionImage?.sm_url || optionImage?.md_url || optionImage?.url;

                return (
                    <Button
                 
                        key={value.id}
                        variant={selectedOption?.id == value.id ? "solid" : "outline"}
                        onClick={e => onSelectOption(value, optionIndex, true)}
                    >
                        <HStack gap={2}>
                            {optionImageSrc &&
                                <Image src={optionImageSrc} boxSize="32px" fit="cover" borderRadius="sm" />
                            }
                            <Text as="span">{value.title}</Text>
                        </HStack>
                    </Button>
                )
            })}
        </Wrap>
    )
}

export default VariantOptionValues
